import Button from '../../../components/Button';
import Card from '../../../components/Card';
import useModalState from '../../../context/modal/useModalState';
import { useWeb3React } from '@web3-react/core';
import { BasePath } from '../../../config/constants';
import UserReferral from '../../../components/UserReferral';

type LeaderboardStatusTypes = 'not-connected' | 'no-trades' | 'empty-data';

type LeaderboardStatusProps = {
    type: LeaderboardStatusTypes;
};

const LeaderboardStatus: React.FC<LeaderboardStatusProps> = ({ type }) => {
    const render = (type: LeaderboardStatusTypes) => {
        switch (type) {
            case 'not-connected':
                return <NotConnected />;
            case 'no-trades':
                return <NoTrades />;
            case 'empty-data':
                return <EmptyData />;
            default:
                return null;
        }
    };

    return <Card className={`leaderboard-status ${type}`}>{render(type)}</Card>;
};

export default LeaderboardStatus;

const NotConnected = () => {
    const { openModal } = useModalState();

    return (
        <Button onClick={() => openModal('connectWalletModal')}>
            Connect Wallet to view your rank
        </Button>
    );
};

const NoTrades = () => {
    const { account } = useWeb3React();

    return (
        <>
            <div className='placeholder'>
                <div className='leaderboard__rank'>0</div>
                <UserReferral userAddress={account} />
            </div>
            <span>You have no trades</span>
            <Button internalLink={BasePath.TRADE}>Make a Trade</Button>
        </>
    );
};

const EmptyData = () => <>Leaderboard is currently empty...</>;
